import { RestTypeConnection } from "@connection";
import { FileLogger } from "@logger";
import { BaseResource } from "./_base.resource";

export abstract class BaseRestResource extends BaseResource {
	private connection: RestTypeConnection;

	constructor(connection: RestTypeConnection, { logger = null }: { logger?: FileLogger | null } = {}) {
		super({ logger });
		this.connection = connection;
	}

	protected async get(uri: string, { params = null, fullResponse = false, headers = {} }: { params?: any, fullResponse?: boolean, headers?: any } = {}): Promise<any> {
		return await this.connection.exec("GET", uri, { params, fullResponse, headers });
	}

	protected async post(uri: string, { params = null, body = null, fullResponse = false, headers = {} }: { params?: any, body?: any, fullResponse?: boolean, headers?: any } = {}): Promise<any> {
		return await this.connection.exec("POST", uri, { params, body, fullResponse, headers });
	}

	protected async put(uri: string, { params = null, body = null, fullResponse = false, headers = {} }: { params?: any, body?: any, fullResponse?: boolean, headers?: any } = {}): Promise<any> {
		return await this.connection.exec("PUT", uri, { params, body, fullResponse, headers });
	}

	protected async delete(uri: string, { params = null, fullResponse = false, headers = {} }: { params?: any, fullResponse?: boolean, headers?: any } = {}): Promise<any> {
		return await this.connection.exec("DELETE", uri, { params, fullResponse, headers });
	}
}